
import React, { useRef, useEffect, useState } from "react";

import './styles1.css'


/*
 options: [
        { nombre:'tarea1.doc', filename:'345345fsdf.doc' },
        { nombre:'taread4 df.jpg', filename:'234234234.jpg' },
        { nombre:'foto.png', filename:'234234234.png' }, 
      ],

dissabled:dissabled 
 */
const ListFile2 = ({ name, options, value, fileURL, 
                    onChange, onDelete, showDelete, showDown,
                    disabled, ...props }) => {
    // 
    const [label, setLabel] = useState(value);
    //const defaultChecked = checked ? checked : false;
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    //const [isChecked, setIsChecked] = useState(defaultChecked);
    const click_func =(e)=>{
      console.log("click_func")
      //--- a cada click tenemos que hacer que cambie de valor
    
      //------ preparamos para enviar afuera
      e.target.name = name
      e.target.value = 'new_value'
      //console.log(e.target.value)
      onChange(e);
    }
    //--------------------------------
    const click_delete=(item)=>{
      //----borramos un item
      onDelete(item);
    }

    const click_ver=(item)=>{
      console.log("click_ver")
      //----borramos un item
      let fileURL1 = fileURL + item.filename;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL1,'',windowFeatures);
    }

    const click_down=(item)=>{
      console.log("click_down")
      //----borramos un item
      //onDelete(item);
    }
    //-----------------------------------
    return (
      <div>
      
      <table className="tabla_files">
        <thead class="">
          <tr class="font-bold  bg-gray-50">
            <th colSpan={2} class="text-center border-blue-500 " style={{padding: 10 }} >Archivos</th>
          </tr>
        </thead>
        {/*[{"nombre":"users.sql","filename":"8SmY1749847189.sql"} */}
        <tbody class="text-gray-700"  style={{backgroundColor: 'white'}}>
          {
            options.map( (item, index) => (
              <tr key={ index } className="">
                <td class="" style={{ width: '90%' }}>
                  { item.nombre}
                </td>
                <td class="" style={{ display: 'flex' }}>
                  { showDelete &&
                  <span className="right-icon icon1" onClick={()=> click_delete(item) }
                    title="Eliminar">
                    <i className=" fa fa-trash fa-lg" style={{color: '#dc3545'}}></i>
                  </span>
                  }
                  &nbsp;
                  { showDown &&
                  <span className="right-icon icon1" onClick={()=> click_down(item) }
                      title="Descargar">
                    <i className=" fa fa-arrow-circle-down fa-lg" style={{color: '#4484f7'}}></i>
                  </span>
                  }
                  &nbsp;
                  <span className="right-icon cursor_pointer"  style={{ color: '#0d6efd'}}
                        onClick={()=>click_ver(item)}>
                    <i className=" fa fa-eye fa-lg"></i>
                  </span>
                </td>
              </tr>
            ))
          }
          
        </tbody>
      </table>
      </div>
    );
  }
  
  export default ListFile2;


  /*<NuCheckbox
      label=""
      name="chk_e1"
      value={this.state.form.chk_e1}
      onChange={ this.handleChangeForm }
    />*/



    /*
    <li>
          Item One
          <span className="badge">2</span>
        </li>
        <li>
          Item Two
          <span className="badge">10</span>
        </li>
        <li>
          Item Three
          <span className="badge">9</span>
        </li>
        <li>
          Item Four
          <span className="badge">0</span>
        </li>
         */